import type { Brand } from "../types";
import BrandListItem from "./brand-list-item";

export interface BrandListProps {
	brands: Brand[];
	currentWorkspaceId: string;
	onSwitch: (brandId: string) => void;
}

export default function BrandList({ brands, currentWorkspaceId, onSwitch }: BrandListProps) {
	return (
		<div className="space-y-2">
			{brands.map((brand, index) => (
				<BrandListItem key={`${brand.id}-${index}`} brand={brand} isSelected={brand.id === currentWorkspaceId} onSwitch={onSwitch} />
			))}
		</div>
	);
}
